<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Articles",
    }
</script>

<style scoped>

</style>